<template>
    <section id="navigation">
        <v-app-bar
            class="app-bar"
            color="primary"
            height="72px"
            app
            flat
        >

            <!-- Navbar Open Button -->
            <v-app-bar-nav-icon
                color="white"
                large
                @click="showDrawer = true"
            />

            <!-- Logo -->
            <img
                class="logo"
                src="@/assets/images/logo-white-horizontal.svg"
            />
            <!-- Route Title -->
            <h1 class="route-title route-title--separator">-</h1>
            <h1 class="route-title">{{ routeTitle }}</h1>
            <v-spacer />

            <!-- Offline Notification -->
            <TheOfflineNotification :isOnline="isOnline"/>
            <v-spacer />

            <!-- User Name & Location Name -->
            <div class="user-information">
                <span class="user-information__name">
                    <span class='user-information__welcome'>Welcome,</span> {{ name }}
                </span>
                <br>
                <span class="user-information__institution">
                    {{ location }}
                </span>
            </div>
        </v-app-bar>
        <TheNavbarDrawer
            v-model="showDrawer"
            :isOnline="isOnline"
        />
    </section>
</template>

<script>
// Vuex
import { mapGetters, mapState } from 'vuex';

// Components
import TheNavbarDrawer from '@/components/TheNavbarDrawer';
import TheOfflineNotification from '@/components/TheOfflineNotification';

export default {
    name: 'TheHeader',
    components: {
        TheNavbarDrawer,
        TheOfflineNotification,
    },
    props: {
        isOnline: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            showDrawer: false,
        };
    },
    computed: {
        ...mapGetters( {
            isLoggedIn: 'User/isLoggedIn',
            hasWebsiteInfo: 'Website/hasInfo',
        } ),
        ...mapState( {
            username: ( state ) => state.User.name,
            locationName: ( state ) => state.Website.info.name,
        } ),
        /** @returns { String } */
        name() {
            return this.isLoggedIn
                ? this.username
                : '';
        },
        /** @returns { String } */
        location() {
            return this.hasWebsiteInfo
                ? this.locationName
                : '';
        },
        /** @returns { String } */
        routeTitle() {
            return this.$route.meta.documentTitle;
        },
    },
};
</script>

<style lang="scss" scoped>
#app .app-bar {
    .route-title {
        color:  $colors-white;
        font-size: 1.125rem;
        padding-left: .5rem;
        @include mixins-above(desktop) {
            font-size: 1.5rem;
            margin-bottom:0.125rem;
        }
        @include mixins-above(tablet) {
            padding-left: 0;
            padding-bottom: .125rem;
        }
        &--separator {
            display:none;
            @include mixins-above(tablet) {
                display:block;
                padding-right: .375rem;
            }
        }
    }
    .user-information {
        color:  $colors-white;
        text-align: right;
        line-height: 1rem;

        &__name {
            font-size: 1rem;
        }

        &__institution {
            font-weight: 300;
            font-size: 0.6875rem;
        }
        &__welcome {
            display: none;
            @include mixins-above(tablet) {
                display: initial;
            }
        }
    }
}

.logo {
    margin-left: -.75rem;
    margin-right: -.75rem;
    transform: scale(.75);
    @include mixins-above(desktop) {
        transform: scale(1);
        margin-left:.5rem;
        margin-right: .5rem;
    }
    display:none;
    @include mixins-above(tablet) {
        display:block;
    }
}
</style>
